import styled from 'styled-components';
import { StyledAdminListRow } from '../../AdminListHeaderCell/styles/StyledAdminListRow';

export const StyledAdminDeviceGroupsListRow = styled.div`
  ${StyledAdminListRow}

  .admin-list-cell-container {
    &.adjust {
      width: 19rem;
      flex-grow: initial;
    }
  }

  @media screen and (max-width: 1100px) {
    width: 110rem;
  }
`;
